/* eslint-disable react/no-unused-prop-types */
import {
  AnchorButton,
  Button,
  Intent,
  PopoverPosition,
} from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import { Unlink } from 'src/components/icons/Unlink';
import { TEST_IDS } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';

type EntityDrawerButtonProps = {
  disabled?: boolean;
  onClick: () => void;
  tooltip?: string;
};

export const AddButton: React.VFC<EntityDrawerButtonProps> = ({
  disabled,
  onClick,
  tooltip,
}) => (
  <Tooltip content={tooltip || ''} disabled={!tooltip}>
    <AnchorButton
      data-testid={TEST_IDS.projectDiagram.entityDrawer.addButton}
      disabled={disabled}
      intent={Intent.PRIMARY}
      onClick={onClick}
      outlined
      text={copy.components.projectDiagram.entityDrawerButtons.add}
    />
  </Tooltip>
);

export const EditButton: React.VFC<EntityDrawerButtonProps> = ({ onClick }) => (
  <Tooltip content={copy.components.projectDiagram.entityDrawerButtons.edit}>
    <Button
      className="sd-hidden-until-hover"
      data-testid={TEST_IDS.projectDiagram.entityDrawer.editButton}
      icon={IconNames.EDIT}
      minimal
      onClick={onClick}
    />
  </Tooltip>
);

export const UnlinkButton: React.VFC<EntityDrawerButtonProps> = ({
  disabled,
  onClick,
}) => (
  <Tooltip
    content={
      disabled
        ? copy.components.projectDiagram.entityDrawerButtons.unlinkDisabled
        : copy.components.projectDiagram.entityDrawerButtons.unlink
    }
    // auto is default, but left here for readability
    position={disabled ? PopoverPosition.BOTTOM_LEFT : PopoverPosition.AUTO}
  >
    <Button
      className="sd-hidden-until-hover"
      data-testid={TEST_IDS.projectDiagram.entityDrawer.unlinkButton}
      disabled={disabled}
      icon={<Unlink />}
      minimal
      onClick={onClick}
    />
  </Tooltip>
);

export const UpdateButton: React.VFC<EntityDrawerButtonProps> = ({
  disabled,
  onClick,
  tooltip,
}) => (
  <Tooltip content={tooltip || ''} disabled={!tooltip}>
    <AnchorButton
      data-testid={TEST_IDS.projectDiagram.entityDrawer.updateButton}
      disabled={disabled}
      intent={Intent.PRIMARY}
      onClick={onClick}
      outlined
      text={copy.components.projectDiagram.entityDrawerButtons.update}
    />
  </Tooltip>
);
